import { DateTime } from "luxon";

export const defaultRefreshInterval = 1000;

export const calculateDifferenceFromNow = (datetime: DateTime, format: string, addTimestamp: string = null): string =>
{
    const now = DateTime.fromJSDate(new Date());
    const started = DateTime.fromJSDate(new Date(String(datetime)));
    const difference = now.diff(started);

    if (addTimestamp)
    {
        const [ hours, minutes ] = addTimestamp.split(':').map(string => Number(string));

        return difference.plus( { hours, minutes } ).toFormat(format);
    }
    else
        return difference.toFormat(format);
};

export const calculateDifference = (olderDate: DateTime, newerDate: DateTime, format: string): string =>
{
    const difference = newerDate.diff(olderDate);

    return difference.toFormat(format);
};

interface TimeOverall {
    string: string;
    data: { hours: number, minutes: number }
}

export const getTimeFromOverallTime = (timeOverall: string): TimeOverall =>
{
    const [ hours, minutes ] = timeOverall.split(':');

    return {
        string: `${hours}:${minutes}`,
        data: { hours: Number(hours), minutes: Number(minutes) }
    };
};